import Icon, { SettingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import themeGet from '@styled-system/theme-get';
import { Menu } from 'antd';
import { generatePath, Link } from 'react-router-dom';
import styled from 'styled-components';
import {
    //ANALYTICS,
    INSIGHTS,
    ARCHIVE,
    //TENSILE,
    //CERTIFICATION,
    //PORTABLE_ARCHIVE,
    //PORTABLE_INSIGHTS,
    //PORTABLE_CERTIFICATION,
    ADMIN,
} from '../../../settings/urls';

import { ReactComponent as InsightsIcon } from '../../../assets/img/InsightsIcon.svg';
import { ReactComponent as ArchiveIcon } from '../../../assets/img/ArchiveIcon.svg';
//import { ReactComponent as AnalyticsIcon } from '../../../assets/img/AnalyticsIcon.svg';
//import { ReactComponent as TensileIcon } from '../../../assets/img/TensileIcon.svg';
//import { ReactComponent as CertificationIcon } from '../../../assets/img/CertificationIcon.svg';
//import { ReactComponent as PortableIcon } from '../../../assets/img/PortableIcon.svg';
import { ReactComponent as BenchtopIcon } from '../../../assets/img/BenchtopIcon.svg';
import { MOBILE_BREAKPOINT_PX, FRNT_VER } from '../../../settings/constants';
import { useCompanyCtx } from '../../../context/integrations/Company';
import { useVersionCtx } from '../../../context/integrations/Version';

const SubMenuWrapper = styled.div`
    margin-left: 8px;
    margin-bottom: 16px;
    padding: 8px;
    background-color: white;

    @media (min-width: ${MOBILE_BREAKPOINT_PX}) {
        border: 1px solid #e5e5e5;
        border-radius: ${themeGet('border.standard.radius')};
        border: ${themeGet('border.standard.color')} solid
            ${themeGet('border.standard.size')};
    }
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const IconWrapper = styled.div`
    padding: 8px 0;
    font-size: 30px;
    width: 100%;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Title = styled.div`
    color: black;
    margin-top: 4px;
    font-size: ${themeGet('font.small')};
    text-align: center;
    display: block;
`;

const menuItems = [
    {
        icon: (
            <IconWrapper>
                <Icon component={BenchtopIcon} />
                <Title>Benchtop</Title>
            </IconWrapper>
        ),
        link: generatePath(`/${ARCHIVE}`),
        key: 'Benchtop',
        submenu: [
            {
                key: 'Archive',
                link: generatePath(`/${ARCHIVE}`),
                icon: <Icon component={ArchiveIcon} />,
            },
            {
                key: 'Insights',
                link: generatePath(`/${INSIGHTS}`),
                icon: <Icon component={InsightsIcon} />,
            },
            /*
            {
                key: 'Analytics',
                link: generatePath(`/${ANALYTICS}`),
                icon: <Icon component={AnalyticsIcon} />,
            },
            {
                key: 'Tensile',
                link: generatePath(`/${TENSILE}`),
                icon: <Icon component={TensileIcon} />,
            },
            {
                key: 'Certification',
                link: generatePath(`/${CERTIFICATION}`),
                icon: <Icon component={CertificationIcon} />,
            },
 */
        ],
    },
    /*
    {
        icon: (
            <IconWrapper>
                <Icon component={PortableIcon} />
                <Title>Portable</Title>
            </IconWrapper>
        ),
        key: 'Portable',
        link: generatePath(`/${PORTABLE_ARCHIVE}`),
        submenu: [
            {
                key: 'Archive',
                link: generatePath(`/${PORTABLE_ARCHIVE}`),
                icon: <Icon component={ArchiveIcon} />,
            },
            {
                key: 'Insights',
                link: generatePath(`/${PORTABLE_INSIGHTS}`),
                icon: <Icon component={InsightsIcon} />,
                disabled: true,
            },
            {
                key: 'Certification',
                link: generatePath(`/${PORTABLE_CERTIFICATION}`),
                icon: <Icon component={CertificationIcon} />,
                disabled: true,
            },
        ],
    },
    */
    {
        key: 'Admin Panel',
        icon: (
            <IconWrapper>
                <Icon component={SettingOutlined} />
                <Title>Admin Panel</Title>
            </IconWrapper>
        ),

        link: generatePath(`/${ADMIN}`),
    },
];

const StyledMenu = styled(Menu)`
    border: none;
    @media (min-width: ${MOBILE_BREAKPOINT_PX}) {
        svg {
            font-size: 30px;
        }
        .ant-menu-item {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 55px;
            padding: 0 !important;
            width: 55px;
            line-height: unset;
            .ant-menu-item-icon {
                line-height: unset !important;
                min-width: 30px;
                .anticon {
                    line-height: unset !important;
                }
            }
            .ant-menu-title-content {
                display: none !important;
            }

            // Icon

            border-radius: ${themeGet('border.standard.radius')};
            border: ${themeGet('border.standard.color')} solid
                ${themeGet('border.standard.size')};
        }
    }
    .ant-menu-item.ant-menu-item-selected {
        background: #e5e5e5;
        color: ${themeGet('color.primary')};
    }
`;

const BlackLink = styled(Link)`
    color: inherit;
`;

const Active = styled.div`
    color: ${themeGet('color.primary')};
`;

const getSectionIcon = (icon, link, isActive, hasSubmenu) => {
    if (isActive) {
        return hasSubmenu ? icon : <Active>{icon}</Active>;
    }
    return <BlackLink to={link}>{icon}</BlackLink>;
};

const mapSubmenu = (submenu) =>
    submenu?.map(({ key, icon, link, disabled }) => ({
        key,
        icon: <Link to={link}>{icon}</Link>,
        label: <Link to={link}>{key}</Link>,
        disabled,
    }));

const DashboardSidebar = ({ sectionActive, active, isMobile }) => {
    const company = useCompanyCtx();
    const bckndVersion = useVersionCtx();
    const versions = (
        <>
            {FRNT_VER} <br />
            {bckndVersion?.version?.version}
        </>
    );
    const activeSection =
        menuItems.find((item) => item.key === sectionActive) || [];
    const items = [
        activeSection,
        ...menuItems.filter((item) => item.key !== sectionActive),
    ].filter(
        ({ key }) => !(key === 'Admin Panel' && !company?.userInfo?.isAdmin)
    );

    return (
        <>
            {items.map(({ icon, link, key, submenu }) => (
                <SubMenuWrapper key={key}>
                    {getSectionIcon(
                        icon,
                        link,
                        sectionActive === key,
                        !!submenu
                    )}
                    {sectionActive === key && (
                        <StyledMenu
                            mode={isMobile ? 'vertical' : 'inline'}
                            selectedKeys={[active]}
                            items={mapSubmenu(submenu)}
                        />
                    )}
                </SubMenuWrapper>
            ))}
            <Tooltip title={<>{versions}</>}>
                <div className="version">Version</div>
            </Tooltip>
        </>
    );
};

export default DashboardSidebar;
